import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../common/index';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic/index';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import {
  useGetErasmusSubjectsQuery,
  useDeleteErasmusSubjectMutation,
} from '../../../../../redux/services/erasmusSubjects';
import ErasmusSubjectsTable from './ErasmusSubjectsTable';
import SubjectPreviewModal from './SubjectPreviewModal/SubjectPreviewModal';

const ErasmusSubjectsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    data: erasmusSubjects,
    isLoading,
    refetch,
  } = useGetErasmusSubjectsQuery();
  const [deleteErasmusSubject, { isSuccess: isDeleteSuccess }] =
    useDeleteErasmusSubjectMutation();
  const { deleteSuccess } = useToastMessages();

  // Preview modal state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSubject, setPreviewSubject] = useState(null);

  useEffect(() => {
    if (isDeleteSuccess) {
      deleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  // Merge "row" from table with full subject from API (full has priority)
  const handlePreviewClick = (row) => {
    const subjectId = row?.erasmus_subject_id ?? row?.id;
    const full = (erasmusSubjects || []).find((s) => s?.id === subjectId);

    const merged = {
      ...row,
      ...full,
      // unify university name
      university_name:
        full?.university?.name ?? row?.university_name ?? row?.university ?? '',
      // normalize local_subjects
      local_subjects: Array.isArray(full?.local_subjects)
        ? full.local_subjects
        : Array.isArray(row?.local_subjects)
          ? row.local_subjects
          : [],
      //      keep flat local code/name if present in row
      local_subject_code:
        row?.local_subject_code ?? full?.local_subject_code ?? '',
      local_subject_name:
        row?.local_subject_name ?? full?.local_subject_name ?? '',
    };

    setPreviewSubject(merged);
    setPreviewOpen(true);
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Správa predmetov')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Nový predmet')}
        createUrl={routes.cmsErasmusSubjectsCreate}
        permissionsBasic={'erasmus-subjects'}
      />

      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <ErasmusSubjectsTable
            erasmusSubjects={erasmusSubjects}
            onDelete={(record) => deleteErasmusSubject(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsErasmusSubjectsEdit}/${record.id}`)
            }
            onPreviewClick={handlePreviewClick}
          />
        </CollapseBlock>
      </div>

      <SubjectPreviewModal
        open={previewOpen}
        subject={previewSubject}
        onClose={() => setPreviewOpen(false)}
      />
    </>
  );
};

export default ErasmusSubjectsPage;
